import React, { ChangeEvent } from "react";
import PaperClipIconSvg from "../../../../assets/icons/react-svg/PaperClip";
import {
  FilePreviewItem,
  FileUpload,
} from "../../main/feedback-page-new/sub-components/FileUploadItems";
import { UploadedAttachment } from "./sidebarFeedback.utils";
import styles from "./SidebarFeedbackModal.module.css";

type SidebarFeedbackAttachmentsProps = {
  label: string;
  attachments: UploadedAttachment[];
  maxFiles: number;
  isUploading: boolean;
  uploadingFileName: string;
  uploadingFileSize: string;
  uploadProgress: number;
  uploadingLabel: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onRemove: (index: number) => void;
};

export default function SidebarFeedbackAttachments({
  label,
  attachments,
  maxFiles,
  isUploading,
  uploadingFileName,
  uploadingFileSize,
  uploadProgress,
  uploadingLabel,
  onChange,
  onRemove,
}: SidebarFeedbackAttachmentsProps) {
  return (
    <div className={styles.attachmentsRow}>
      <FileUpload
        label={label}
        isShowInfoIcon={true}
        infoTooltipContent="Supported file types are (JPG, PNG, PDF, DOCX, XLSX, CSV, MP4, MP3). Max 25MB per file."
        accept=".jpg,.jpeg,.png,.pdf,.docx,.xlsx,.csv,.mp4,.mp3"
        fileUploadIcon={<PaperClipIconSvg />}
        isDisabled={attachments.length >= maxFiles || isUploading}
        isUploading={isUploading}
        onChange={onChange}
        showProgress={isUploading}
        progressData={{
          fileName: uploadingFileName || uploadingLabel,
          fileSize: uploadingFileSize || "",
          progress: uploadProgress,
        }}
      >
        {attachments.map((item, index) =>
          item.isUploading ? null : (
            <FilePreviewItem
              key={item.id || `${item.filename}-${index}`}
              label={item.filename}
              onRemove={() => onRemove(index)}
            />
          )
        )}
      </FileUpload>
    </div>
  );
}
